import React from "react";

import Logo from "../../assets/images/logo-white.png";
import { Link } from "react-router-dom";

const Footer = () => {
    // State to manage dropdown visibility

    return (
        <footer className="bg-[#394C71] border-gray-200 box-shadow py-4 md:py-8 2xl:py-12">
            <div className="container">
                <div className="flex-center-between">
                    <Link to={"/"}>
                        <img src={Logo} className="h-10 2xl:h-12" alt="Flowbite Logo" />
                    </Link>
                    <ul className="font-medium flex md:border-0">
                        <li>
                            <Link to={'/privacy'} className="block font-light py-2 px-3 text-gray-200">Privacy policy</Link>
                        </li>
                        <li>
                            <Link to={'/terms'} className="block font-light py-2 px-3 text-gray-200">Terms of Use</Link>
                        </li>
                    </ul>
                </div>
                <div className="font-light text-gray-200 text-center mt-7">This product was supported by cooperative agreement number 15POVC-23-GK-01415-NONF, awarded by the Office for Victims of Crime, Office of Justice Programs, U.S. Department of Justice. The opinions, findings, and conclusions or recommendations expressed in this product are those of the contributors and do not necessarily represent the official position or policies of the U.S. Department of Justice.</div>
                <hr className=" border-white border-opacity-20 h-0 my-4 md:my-8 2xl:my-10" />
                <p className="text-gray-200 text-center">© {new Date().getFullYear()} Safe Shelter Collaborative. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
